import { createSelector } from 'reselect';
import pageSelector from './pageSelector';

export default createSelector(pageSelector, ({ hero = {} }) => hero);

// Need to do this until the Page API can handle device specific images
// Selector takes a content and returns the imageHref
const heroImageParams = '&templateId=espn.web.hero.1&size=xxl';
const contentSelector = (content = {}) => content;
export const heroImageSelector = createSelector(contentSelector, ({ imageHref = '' }) =>
    (imageHref.indexOf('espncdn.com/stitcher/artwork/collections') === -1 ? imageHref : `${imageHref}${heroImageParams}`)
);



// WEBPACK FOOTER //
// ./app/common/selectors/heroSelector.js